<div class="d-flex flex-row">
	<div class="d-inline-flex">
		<mat-form-field
			appearance="fill"
			matTooltipPosition="right"
			matTooltip="Koszt Transportu / Pilot / Przewodnik / Nocleg dla
        załogi"
			class="example-form-field"
		>
			<mat-label>Koszt</mat-label>
			<input
				[ngModel]="
					this.priceSettingData.crewCost || this.priceSettingData.crewCost === 0
						? (this.priceSettingData.crewCost | price)
						: null
				"
				(ngModelChange)="this.priceSettingData.crewCost = updatePrice($event)"
				required
				matInput
				[disabled]="editable"
				#input
				type="number"
				(keydown)="digitLimit($event)"
			/>
			<span class="right-addon ps-2"> PLN </span>
		</mat-form-field>
	</div>
</div>
<hr class="my-4" />
<div class="d-flex flex-row">
	<div class="d-inline-flex">
		<mat-form-field appearance="fill">
			<mat-label>Waluta</mat-label>
			<mat-select
				[disabled]="editable"
				[(ngModel)]="priceSettingData.currency"
				(selectionChange)="valuechange()"
				matNativeControl
			>
				<!-- <mat-option value="" selected disabled></mat-option> -->
				<mat-option [value]="item.id" *ngFor="let item of currency">{{ item.name }}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="d-inline-flex ms-5">
		<mat-form-field appearance="fill">
			<mat-label>Sposób liczenia</mat-label>
			<mat-select [(ngModel)]="priceSettingData.chargingMode" [disabled]="editable" matNativeControl>
				<!-- <mat-option value="" selected></mat-option> -->
				<mat-option value="D">Dzień</mat-option>
				<mat-option value="T">Wycieczka</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</div>
<div class="d-flex">
	<h6 class="my-4 fw-bold board-first">Wyżywienie</h6>
	<h6 class="my-4 fw-bold ms-5 board">Koszt</h6>
	<h6 class="my-4 fw-bold ms-5 board">Koszt PLN</h6>
	<h6 class="my-4 fw-bold ms-5 board">Cena sprzedaży</h6>
	<h6 class="my-4 fw-bold board-last">Aktywny</h6>
</div>
<div class="d-flex" *ngFor="let item of board; let i = index">
	<h6 class="board-first">
		{{ item.name }}
	</h6>
	<div class="d-inline-flex ms-5 board">
		<mat-form-field appearance="fill" class="example-form-field">
			<mat-label>Koszt</mat-label>
			<input
				[disabled]="editable"
				[ngModel]="item.cost || item.cost === 0 ? (item.cost | price) : null"
				(ngModelChange)="item.cost = updatePrice($event)"
				(change)="valuechange()"
				matInput
				#input
				type="number"
				(keydown)="digitLimit($event)"
			/>
			<span class="right-addon ps-2"> {{ selectedCurrency?.code }} </span>
		</mat-form-field>
	</div>
	<div class="d-inline-flex ms-5 board">
		<mat-form-field appearance="fill" class="example-form-field">
			<mat-label>Koszt</mat-label>
			<input
				disabled
				[ngModel]="item.costPLN || item.costPLN === 0 ? (item.costPLN | price) : null"
				(ngModelChange)="item.costPLN = updatePrice($event)"
				matInput
				type="number"
			/>
			<span class="right-addon ps-2"> PLN </span>
		</mat-form-field>
	</div>
	<div class="d-inline-flex ms-5 board">
		<mat-form-field appearance="fill" class="example-form-field">
			<mat-label>Cena</mat-label>
			<input
				[ngModel]="item.sellingPrice || item.sellingPrice === 0 ? (item.sellingPrice | price) : null"
				(ngModelChange)="item.sellingPrice = updatePrice($event)"
				[disabled]="editable"
				matInput
				#input
				(change)="valuechange()"
				type="number"
				(keydown)="digitLimit($event)"
			/>
			<span class="right-addon ps-2"> PLN </span>
		</mat-form-field>
	</div>
	<div class="d-inline-flex board-last checkbox-position">
		<mat-checkbox color="primary" [(ngModel)]="item.isActive" [disabled]="editable"></mat-checkbox>
	</div>
	<div class="d-inline-flex button-position">
		<button
			[ngClass]="{
				buttonnone: buttonnone === true,
			}"
			[disabled]="editable"
			mat-raised-button
			color="primary"
			(click)="clearBoard(i)"
		>
			<i class="fas fa-trash"></i>
			Wyczyść
		</button>
	</div>
</div>
<hr class="my-4" />
<div class="d-flex">
	<div class="flex-column">
		<h6 class="my-4 fw-bold board-last d-flex">Aktywny</h6>
		<div class="d-flex" *ngFor="let element of priceOption">
			<h6 class="board-first">{{ element.name }}</h6>
			<div class="d-inline-flex ms-5 board">
				<mat-form-field appearance="fill" class="example-form-field">
					<mat-label>Koszt</mat-label>
					<input
						[disabled]="editable"
						(change)="convertDecimal()"
						[ngModel]="
							element.method === '%'
								? element.cost
									? (element.cost | PercentValue)
									: null
								: element.cost
									? (element.cost | price)
									: null
						"
						(ngModelChange)="
							element.method === '%'
								? (element.cost = updatePercent($event))
								: (element.cost = updatePrice($event))
						"
						matInput
						#input
						type="number"
						(keydown)="digitLimit($event)"
					/>
				</mat-form-field>
			</div>
			<div class="d-inline-flex ms-5 board">
				<mat-form-field appearance="fill">
					<mat-label>Waluta</mat-label>
					<mat-select [disabled]="editable" [(ngModel)]="element.currency">
						@for (item of currency; track $index) {
							<mat-option [value]="item.id">{{ item.name }}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
			<div class="d-inline-flex board-last checkbox-position">
				<mat-checkbox [(ngModel)]="element.isActive" color="primary" [disabled]="editable"></mat-checkbox>
			</div>
		</div>
	</div>
	<div class="d-flex justify-content-end align-self-end w-100 mb-3 me-4">
		<button
			class="mx-4 my-auto"
			*ngIf="!productData"
			[ngClass]="{
				fixed_button: data !== undefined,
				buttonnone: buttonnone === true,
			}"
			mat-raised-button
			color="primary"
			[disabled]="editable"
			(click)="submit()"
		>
			<i class="fa-regular fa-pen-to-square"></i>
			Zapisz ustawienia
		</button>
	</div>
</div>
